import { METRICS } from './misc';

const MAP_MISSING_VALUES_LABELS = {
  low_engagement: 'L.E.',
  less_than_zero: '<0.01%',
  affinity_null: '-'
};

const getFixedParam = (data, fixed) => {
  let choosenFixed = fixed;
  const dataToFixed = (data * 10) % 10;

  if (dataToFixed % 1 === 0) {
    choosenFixed = data % 1 === 0 ? 0 : 1;
  }
  return choosenFixed;
};

const formattedValue = (data, type, fixed = 2) => {
  let choosenFixed = getFixedParam(data, fixed);

  if (data === 0) {
    return type === METRICS.AFFINITY
      ? data + 'x'
      : type === METRICS.RELEVANCY
      ? data
      : data + '%';
  }
  if (!data) {
    return type === METRICS.AFFINITY || type === METRICS.RELEVANCY
      ? MAP_MISSING_VALUES_LABELS.affinity_null
      : MAP_MISSING_VALUES_LABELS.low_engagement;
  }

  if (type === METRICS.AFFINITY) {
    return data.toFixed(choosenFixed) + 'x';
  }

  if (type === METRICS.RELEVANCY) {
    return data.toFixed(choosenFixed);
  }

  const dataToFixed = data.toFixed(4);
  if (dataToFixed === '0.0000') {
    return MAP_MISSING_VALUES_LABELS.less_than_zero;
  }
  const dataToFixedPerCent = Number((dataToFixed * 100).toFixed(2));

  choosenFixed = getFixedParam(dataToFixedPerCent, fixed);
  return dataToFixedPerCent.toFixed(choosenFixed) + '%';
};

const formatVisualItemValues = (item) => {
  return {
    ...item,
    base_population_perc: formattedValue(
      item.base_population_perc,
      'base_population_perc'
    ),
    target_audience_population_perc: formattedValue(
      item.target_audience_population_perc,
      'target_audience_population_perc'
    ),
    target_audience_affinity: formattedValue(
      item.target_audience_affinity,
      'target_audience_affinity'
    ),
    penetration: formattedValue(item.penetration, 'penetration')
  };
};

const capitalizeString = (lower) =>
  lower.charAt(0).toUpperCase() + lower.substring(1);

const truncateString = (text, limit) => {
  if (text?.length < limit) return text;
  else return `${text?.slice(0, limit)}...`;
};

export const FormatUtils = {
  formattedValue,
  formatVisualItemValues,
  truncateString,
  capitalizeString
};
